import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const errMsg = (e) => {
  const detail = e?.response?.data?.detail;
  if (detail != null) return apiError(detail);
  if (e?.response) return `The server replied with an unexpected ${e.response.status} response. Please try again or contact the registry.`;
  if (e?.request) return "Could not reach the AdhocArb server. Check your connection and try again.";
  return e?.message || apiError(null);
};

export const ROLE_LABELS = {
  arbitrator: "Arbitrator",
  advocate: "Advocate",
  client: "Client",
  associate: "Associate",
  owner: "Registry Owner",
};

export const HEARING_TYPES = [
  { value: "framing_of_issues", label: "Framing of issues", cls: "bg-indigo-50 text-indigo-900 dark:bg-indigo-950 dark:text-indigo-200" },
  { value: "claimant_evidence", label: "Claimant's evidence", cls: "bg-emerald-50 text-emerald-900 dark:bg-emerald-950 dark:text-emerald-200" },
  { value: "respondent_evidence", label: "Respondent's evidence", cls: "bg-teal-50 text-teal-900 dark:bg-teal-950 dark:text-teal-200" },
  { value: "arguments", label: "Arguments", cls: "bg-amber-50 text-amber-900 dark:bg-amber-950 dark:text-amber-200" },
  { value: "cross_examination", label: "Cross-examination", cls: "bg-rose-50 text-rose-900 dark:bg-rose-950 dark:text-rose-200" },
  { value: "miscellaneous", label: "Miscellaneous", cls: "bg-slate-100 text-slate-800 dark:bg-slate-800 dark:text-slate-200" },
];
export const hearingType = (v) => HEARING_TYPES.find((h) => h.value === v) || HEARING_TYPES[5];

export const CASE_STATUSES = [
  { value: "registered", label: "Registered" },
  { value: "pleadings", label: "Pleadings" },
  { value: "evidence", label: "Evidence" },
  { value: "arguments", label: "Arguments" },
  { value: "reserved", label: "Reserved for Award" },
  { value: "award_passed", label: "Award Passed" },
  { value: "archived", label: "Archived" },
  { value: "closed", label: "Closed" },
];

export const statusLabel = (v) => CASE_STATUSES.find((s) => s.value === v)?.label || v || "—";

export const statusClass = (v) =>
  ({
    registered: "bg-slate-100 text-slate-800 dark:bg-slate-800 dark:text-slate-200",
    pleadings: "bg-blue-50 text-blue-900 dark:bg-blue-950 dark:text-blue-200",
    evidence: "bg-indigo-50 text-indigo-900 dark:bg-indigo-950 dark:text-indigo-200",
    arguments: "bg-amber-50 text-amber-900 dark:bg-amber-950 dark:text-amber-200",
    reserved: "bg-purple-50 text-purple-900 dark:bg-purple-950 dark:text-purple-200",
    award_passed: "bg-green-50 text-green-900 dark:bg-green-950 dark:text-green-200",
    closed: "bg-red-50 text-red-900 dark:bg-red-950 dark:text-red-200",
  }[v] || "bg-slate-100 text-slate-800");

export const verifyClass = (v) =>
  ({
    pending: "bg-amber-50 text-amber-900 dark:bg-amber-950 dark:text-amber-200",
    verified: "bg-green-50 text-green-900 dark:bg-green-950 dark:text-green-200",
    rejected: "bg-red-50 text-red-900 dark:bg-red-950 dark:text-red-200",
  }[v] || "bg-slate-100 text-slate-800");

export const fmtDate = (v) =>
  v ? new Date(v).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "—";

export const fmtDateTime = (v) =>
  v
    ? new Date(v).toLocaleString("en-GB", {
        day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
      })
    : "—";

export const money = (amount, currency = "INR") =>
  amount == null ? "—" : `${currency} ${Number(amount).toLocaleString("en-IN")}`;
